/* ConditionEdge — shows "True" / "False" label on edges from condition nodes */
import { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';

export default memo(function ConditionEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  sourceHandleId,
  style,
  markerEnd,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const isTrue = sourceHandleId === 'true';
  const label = isTrue ? 'True' : 'False';
  const bg = isTrue ? '#dcfce7' : '#fef2f2';
  const color = isTrue ? '#166534' : '#991b1b';

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={style} markerEnd={markerEnd} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            fontSize: 10,
            fontWeight: 600,
            background: bg,
            color,
            padding: '1px 6px',
            borderRadius: 4,
            pointerEvents: 'none',
          }}
          className="nodrag nopan"
        >
          {label}
        </div>
      </EdgeLabelRenderer>
    </>
  );
});
